'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024149 from "./presto.types$-Restricted-Domain-Name$$anon$149.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024150 from "./presto.types$-Restricted-Domain-Name$$anon$150.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RestrictedDomainName$() {
  this.c8k = null;
  this.c8l = false;
  this.c8i = null;
  this.c8j = false;
  this.c8o = null;
  this.c8p = false;
  this.c8m = null;
  this.c8n = false;
  this.c8q = null;
  this.c8r = false;
}
export { $c_Lpresto_types$RestrictedDomainName$ as $c_Lpresto_types$RestrictedDomainName$ };
$p = $c_Lpresto_types$RestrictedDomainName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RestrictedDomainName$;
/** @constructor */
function $h_Lpresto_types$RestrictedDomainName$() {
}
export { $h_Lpresto_types$RestrictedDomainName$ as $h_Lpresto_types$RestrictedDomainName$ };
$h_Lpresto_types$RestrictedDomainName$.prototype = $p;
$p.cHE = (function() {
  if ((!this.c8l)) {
    this.c8k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8l = true;
  }
  return this.c8k;
});
$p.Sx = (function() {
  if ((!this.c8j)) {
    this.c8i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c8j = true;
  }
  return this.c8i;
});
$p.adr = (function() {
  if ((!this.c8p)) {
    this.c8o = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8p = true;
  }
  return this.c8o;
});
$p.cI1 = (function() {
  if ((!this.c8n)) {
    this.c8m = new $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024149.$c_Lpresto_types$RestrictedDomainName$$anon$149(this);
    this.c8n = true;
  }
  return this.c8m;
});
$p.cIy = (function() {
  if ((!this.c8r)) {
    this.c8q = new $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024$0024anon$0024150.$c_Lpresto_types$RestrictedDomainName$$anon$150(this);
    this.c8r = true;
  }
  return this.c8q;
});
var $d_Lpresto_types$RestrictedDomainName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RestrictedDomainName$, "presto.types$RestrictedDomainName$", ({
  a1l: 1,
  D: 1
}));
export { $d_Lpresto_types$RestrictedDomainName$ as $d_Lpresto_types$RestrictedDomainName$ };
var $n_Lpresto_types$RestrictedDomainName$;
function $m_Lpresto_types$RestrictedDomainName$() {
  if ((!$n_Lpresto_types$RestrictedDomainName$)) {
    $n_Lpresto_types$RestrictedDomainName$ = new $c_Lpresto_types$RestrictedDomainName$();
  }
  return $n_Lpresto_types$RestrictedDomainName$;
}
export { $m_Lpresto_types$RestrictedDomainName$ as $m_Lpresto_types$RestrictedDomainName$ };
//# sourceMappingURL=presto.types$-Restricted-Domain-Name$.js.map
